import { ActionCreator } from 'redux';
import {
    ToggleSurveySentAction,
    ChangeTypeOfFinalTransactionCompletedAction
} from './type';
import {
    TOGGLE_SURVEY_SENT_STATUS,
    CHANGE_TYPE_OF_FINAL_TRANSACTION_COMPLETED
} from './constant';
import { TypeOfFinalTransaction, ErrorCodes } from '../../dtos/KioskDtos.dtos';

export const toggleSurveySentStatus: ActionCreator<ToggleSurveySentAction> = (surveySent: boolean) => ({
    type: TOGGLE_SURVEY_SENT_STATUS,
    payload: {
        surveySent
    },
});

export const changeTypeOfFinalTransactionCompleted: ActionCreator<ChangeTypeOfFinalTransactionCompletedAction> = (
    typeOfFinalTransactionCompleted: TypeOfFinalTransaction,
    errorCode: ErrorCodes = ErrorCodes.None
) => ({
    type: CHANGE_TYPE_OF_FINAL_TRANSACTION_COMPLETED,
    payload: {
        typeOfFinalTransactionCompleted,
        errorCode
    },
})


// WEBPACK FOOTER //
// ./src/store/Survey/actions.ts